/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { createEntity, getEntity, reset, updateEntity } from './frequency.reducer';

export const FrequencyUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const frequencyEntity = useAppSelector(state => state.frequency.entity);
  const loading = useAppSelector(state => state.frequency.loading);
  const updating = useAppSelector(state => state.frequency.updating);
  const updateSuccess = useAppSelector(state => state.frequency.updateSuccess);

  const handleClose = () => {
    navigate(`/frequency${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.treatmentCycles !== undefined && typeof values.treatmentCycles !== 'number') {
      values.treatmentCycles = Number(values.treatmentCycles);
    }
    if (values.cycleDuration !== undefined && typeof values.cycleDuration !== 'number') {
      values.cycleDuration = Number(values.cycleDuration);
    }
    if (values.intervalBetweenCycles !== undefined && typeof values.intervalBetweenCycles !== 'number') {
      values.intervalBetweenCycles = Number(values.intervalBetweenCycles);
    }
    if (values.totalTreatmentDuration !== undefined && typeof values.totalTreatmentDuration !== 'number') {
      values.totalTreatmentDuration = Number(values.totalTreatmentDuration);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...frequencyEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...frequencyEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.frequency.home.createOrEditLabel" data-cy="FrequencyCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.frequency.home.createOrEditLabel">Create or edit a Frequency</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="frequency-id"
                  label={translate('tinyMedicRestApp.frequency.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.frequency.treatmentCycles')}
                id="frequency-treatmentCycles"
                name="treatmentCycles"
                data-cy="treatmentCycles"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.frequency.cycleDuration')}
                id="frequency-cycleDuration"
                name="cycleDuration"
                data-cy="cycleDuration"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.frequency.cycleDurationUnits')}
                id="frequency-cycleDurationUnits"
                name="cycleDurationUnits"
                data-cy="cycleDurationUnits"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.frequency.intervalBetweenCycles')}
                id="frequency-intervalBetweenCycles"
                name="intervalBetweenCycles"
                data-cy="intervalBetweenCycles"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.frequency.intervalUnits')}
                id="frequency-intervalUnits"
                name="intervalUnits"
                data-cy="intervalUnits"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.frequency.totalTreatmentDuration')}
                id="frequency-totalTreatmentDuration"
                name="totalTreatmentDuration"
                data-cy="totalTreatmentDuration"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.frequency.totalTreatmentUnits')}
                id="frequency-totalTreatmentUnits"
                name="totalTreatmentUnits"
                data-cy="totalTreatmentUnits"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.frequency.active')}
                id="frequency-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.frequency.cursor')}
                id="frequency-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.frequency.lastUpdated')}
                id="frequency-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.frequency.microSec')}
                id="frequency-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.frequency.timestampEntry')}
                id="frequency-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/frequency" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default FrequencyUpdate;
